class ActiveSection {
    constructor() {
        this._stageSection();

    }

    _stageSection() {
        if ($("body").hasClass("page-template-inicio")) {
            $(".menu-home").addClass("current-menu-item");
        }
        if ($("body").hasClass("page-template-servicios")) {
            $(".menu-servicios").addClass("current-menu-item");
        }
        if ($("body").hasClass("page-template-equipo")) {
            $(".menu-equipo").addClass("current-menu-item");
        }
        if ($("body").hasClass("page-template-clientes")) {
            $(".menu-clientes").addClass("current-menu-item");
        }
         if ($("body").hasClass("page-template-hablemos")) {
            $(".menu-hablemos").addClass("current-menu-item");
        }
       
    }
}

